module.exports = __webpack_public_path__ + "static/media/cooperation1.03a8faf5.png";